<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createLocationTag">
              <div class="col-md-5">
                <h5>Information</h5>
                <br>
                <form-text label="Name" name="name" v-model="locationtag.name" validation="required"></form-text>
                <form-text label="ID" name="id" v-model="locationtag.props.tagid" validation="required"></form-text>
              </div>
              <div class="col-md-5">
                <br>
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../../elements/Form/FormText'
import FormTextArea from '../../../elements/Form/FormTextArea'
import database from '../../../webmaster/Database/database'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createlocationtag',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea
  },
  data () {
    return {
      locationtag: {
        name: '',
        props: {
         tagid: '',
        },
        type: 'Location Tag'
      }
    }
  },
  methods: {
    createLocationTag: function(e){
      var self = this
      e.preventDefault();
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        // Get a key for a new org.
        var curOrgId = self.$store.state.usermain.curOrg.id
        var newDeviceKey = database.getDb().ref().child('orgs').child(curOrgId).child('devices').push().key;
        var updates = {};
        updates['/orgs/' + curOrgId + '/devices/' + newDeviceKey] = self.locationtag;

        database.getDb().ref().update(updates, function(){
          self.$router.push('/admin/devices')
        });
      }, () => {});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateLocationTag.vue?d2f246b4